import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [seconds, setSeconds] = useState(9 * 60 + 22);
  useEffect(() => {
    if (seconds <= 0) return;
    const interval = setInterval(() => {
      setSeconds(s => Math.max(0, s - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, [seconds]);
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="flex items-center justify-center gap-2" aria-live="polite" aria-label={`Tiempo restante: ${mins} minutos y ${secs} segundos`} data-id="element-77">
      <div className="flex flex-col items-center px-4 py-2 rounded-xl min-w-[60px]" style={{
      background: 'rgba(255,255,255,0.15)',
      border: '1px solid rgba(255,255,255,0.2)'
    }} data-id="element-78">
        <span className="text-3xl font-bold text-white leading-none" style={{
        fontFamily: 'var(--font-heading)'
      }} data-id="element-79">
          {pad(mins)}
        </span>
        <span className="text-xs text-white/60 mt-1 uppercase tracking-widest" style={{
        fontFamily: 'var(--font-body)'
      }} data-id="element-80">
          Min
        </span>
      </div>
      <span className="text-2xl font-bold text-white/60" style={{
      fontFamily: 'var(--font-heading)'
    }} aria-hidden="true" data-id="element-81">
        :
      </span>
      <div className="flex flex-col items-center px-4 py-2 rounded-xl min-w-[60px]" style={{
      background: 'rgba(255,255,255,0.15)',
      border: '1px solid rgba(255,255,255,0.2)'
    }} data-id="element-82">
        <span className="text-3xl font-bold text-white leading-none" style={{
        fontFamily: 'var(--font-heading)'
      }} data-id="element-83">
          {pad(secs)}
        </span>
        <span className="text-xs text-white/60 mt-1 uppercase tracking-widest" style={{
        fontFamily: 'var(--font-body)'
      }} data-id="element-84">
          Seg
        </span>
      </div>
    </div>;
}